// import { sortString, sortNumber, toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'KIT_PROCEDURE';

// const sort = function (a, b) {
//   let result = sortNumber(a.status, b.status);
//   if (result !== 0) {
//     return result;
//   }
//   const aName = a.name || null;
//   const bName = b.name || null;
//   result = sortString(aName, bName);
//   if (result !== 0) {
//     return result;
//   }
//   return sortString(a.key, b.key);
// };

const initialState = () => ({
  loading: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const currentData = state.loadedData;
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: [...currentData, ...newData],
        filter: {
          ...state.filter,
          data: [...state.loadedData, ...newData]
        }
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
      const { data, searchTerm } = action.payload;
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          data: searchTerm ? data : state.loadedData
        }
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
